import * as api from '@owl-nest/api-client/next'

export async function list(
  id: number,
  getParams?: URLSearchParams,
  withToken?: boolean,
): Promise<api.HttpResult<api.Pageable<api.ProjectList>>> {
  const response = await api.client('GET /users/:id/projects', {
    getParams,
    urlParams: { id: String(id) },
    withToken: withToken,
  })

  return response.next((success) => {
    return success.body
  })
}
